export const LOGIN = 'LOGIN'
export const SIGNUP = 'SIGNUP'
export const RECOVER = 'RECOVER'
export const RESET = 'RESET'

export const PRIVACY = 'PRIVACY'
export const TERMS = 'TERMS'
